import React from 'react';
import { FadeIn, SectionTitle, Card, Tag } from '../components/UI';
import SERVICES_DATA from '../data/services';

export default function ServicesPage() {
  return (
    <div style={{ paddingTop: 100, background: 'var(--dark)' }}>
      <section style={{ padding: '60px 40px 100px', maxWidth: 1100, margin: '0 auto' }}>
        <FadeIn>
          <SectionTitle subtitle="What We Do" title="Our services" />
          <p style={{
            fontFamily: 'var(--font-body)', fontSize: '1.02rem',
            fontWeight: 300, color: 'var(--text-secondary)',
            lineHeight: 1.75, maxWidth: 620, marginBottom: 44,
          }}>
            A comprehensive range of IT services designed to cover every aspect
            of your technology needs — from strategic planning to hands-on delivery.
          </p>
        </FadeIn>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 28 }}>
          {SERVICES_DATA.map((s, i) => (
            <FadeIn key={i} delay={i * 0.05}>
              <Card>
                <div style={{
                  display: 'flex', alignItems: 'center', gap: 14, marginBottom: 12,
                }}>
                  <span style={{ fontSize: '1.6rem' }}>{s.icon}</span>
                  <h3 style={{
                    fontFamily: 'var(--font-body)', fontSize: '1.2rem',
                    fontWeight: 600, color: 'var(--text-primary)',
                  }}>{s.title}</h3>
                </div>
                <p style={{
                  fontFamily: 'var(--font-body)', fontSize: '0.92rem',
                  fontWeight: 300, color: 'var(--text-secondary)',
                  lineHeight: 1.7, marginBottom: 16,
                }}>{s.desc}</p>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                  {s.features.map((f, j) => <Tag key={j}>{f}</Tag>)}
                </div>
              </Card>
            </FadeIn>
          ))}
        </div>
      </section>
    </div>
  );
}
